import React, { useState, useRef } from "react";
import "../pages/LandingPage.css";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Popup from "reactjs-popup";
import Rules from "./Rules";
//import axios from "axios";
import { toast } from "react-toastify";

const inviteValidation = Yup.object({
  firstName: Yup.string()
    .max(20, "20 वर्ण किंवा कमी असणे आवश्यक आहे")
    .required("पहला नाम अनिवार्य है"),
  lastName: Yup.string()
    .max(25, "20 वर्ण किंवा कमी असणे आवश्यक आहे")
    .required("उपनाम अनिवार्य है"),
  // email: Yup.string()
  //   .email("अवैध ईमेल आयडी")
  //   .required("ईमेल आयडी अनिवार्य आहे"),
  //title: Yup.string().required("शीर्षक अनिवार्य है"),
  // twitterId: Yup.string().required("ट्विटर आईडी अनिवार्य है"),
  contactNo: Yup.string()
    .required("मोबाईल नंबर अनिवार्य आहे")
    .matches(/^[0-9]+$/, "फक्त अंक असणे आवश्यक आहे")
    .min(10, "अगदी 10 अंकी असणे आवश्यक आहे")
    .max(10, "अगदी 10 अंकी असणे आवश्यक आहे"),
  // aadharCard: Yup.mixed()
  //   .required("आधार कार्ड अनिवार्य है")
  //   .test("fileSize", "अधिकतम फ़ाइल आकार 5mb की अनुमति है", (value) => {
  //     //console.log(value);
  //     const maxSize = 1024 * 1024 * 5; //5mb
  //     if (value && value.size > maxSize) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //     //return value && ["application/pdf"].includes(value.type);
  //   }),
  // audioFile: Yup.mixed()
  //   .required("ऑडियो फ़ाइल अनिवार्य है या ऑडियो 10 mb से बड़ी है")
  //   .test("fileSize", "अधिकतम फ़ाइल आकार 50mb की अनुमति है", (value) => {
  //     //console.log(value);
  //     const maxSize = 1024 * 1024 * 50; //200mb
  //     if (value && value.size > maxSize) {
  //       return false;
  //     } else {
  //       //console.log("1");
  //       return true;
  //     }
  //     // return value && ["audio/mpeg"].includes(value.type);
  //   }),
  // postDescription: Yup.string()
  //   .test("len", "300 शब्द या उससे कम का होना चाहिए", (val) => {
  //     if (!val || val.trim().length === 0) {
  //       return false;
  //     }
  //     return !val || (val && val.toString().split(" ").length < 300);
  //   })
  //   .required("रचनात्मक लेखन आवश्यक है"),
  address: Yup.string()
    .max(100, "100 वर्ण किंवा कमी असणे आवश्यक आहे")
    .required("तुमचा पत्ता आवश्यक आहे"),
  city: Yup.string().required("शहर लेखन आवश्यक"),
  state: Yup.string().required("राज्य आवश्यक आहे"),
  pincode: Yup.string().required("पिन कोड आवश्यक आहे"),
  // hashtag: Yup.string()
  //   .matches(
  //     // eslint-disable-next-line no-useless-escape
  //     /(?:\s|^)#[A-Za-z0-9\-\.\_]+(?:\s|$)/g,
  //     "हैशटैग में # शामिल होना चाहिए"
  //   )
  //   .required("हैशटैग फ़ील्ड आवश्यक है"),
  termsAccepted: Yup.boolean().oneOf([true], "अटी आणि शर्तींशी सहमत"),
});

export default function FormikForm({ savePostInDatabase }) {
  const formRef = useRef();
  const [popState, setPopState] = useState(false);
  const [disabled, setDisabled] = useState(false);
  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        firstName: "",
        lastName: "",
        contactNo: "",
        address: "",
        // email: "",
        //title: "",
        // postDescription: "",
        termsAccepted: false,
        //aadharCard: undefined,
        //audioFile: undefined,
        // hashtag: "",
        state: "",
        pincode: "",
        city: "",
        // twitterId: "",
      }}
      validationSchema={inviteValidation}
      onSubmit={async (values, { setSubmitting }) => {
        //console.log(values);
        //* upload files to signurl
        try {
          setDisabled(true);

          let obj = {
            ...values,
            //aadharCardFilePath: data[0].aadharCardFilePath,
            //audioFilePath: data[0].audioFilePath,
          };
          //console.log(obj);
          savePostInDatabase(obj, setDisabled);

          //let aadharCardFileName = values?.aadharCard?.name;
          //let audioFileName = values?.audioFile?.name;

          // let response = await axios.post(
          //   `${process.env.REACT_APP_API_URL}/upload`,
          //   {
          //     //aadharCardFileName,
          //     audioFileName,
          //     email: values?.email,
          //   }
          // );
          // if (response && response.data) {
          //   //console.log(response.data);
          //   const { data } = response.data;
          //   //let aadharCardUrl = data[0].aadhcardPresigned;
          //   let audioCardUrl = data[0].audioFilePresigned;

          //   //let res1 = await axios.put(aadharCardUrl, values.aadharCard);
          //   let res2 = await axios.put(audioCardUrl, values.audioFile);

          //   if (res2 && res2.status === 200) {
          //     let obj = {
          //       ...values,
          //       //aadharCardFilePath: data[0].aadharCardFilePath,
          //       audioFilePath: data[0].audioFilePath,
          //     };

          //     savePostInDatabase(obj, setDisabled);
          //   } else {
          //     toast.error("सहेजने में विफल है. कृपया पुन: प्रयास करें।", {
          //       position: "bottom-center",
          //       autoClose: 4000,
          //       hideProgressBar: false,
          //       closeOnClick: true,
          //       pauseOnHover: true,
          //       draggable: true,
          //       progress: undefined,
          //     });
          //     setDisabled(false);
          //   }
          // } else {
          //   if (response && response.response && response.response.data) {
          //     //console.log(response.response.data);
          //     let data = response.response.data;
          //     if (data.duplicate === true) {
          //       toast.error("इस ईमेल द्वारा पोस्ट पहले ही सबमिट कर दी गई है।", {
          //         position: "bottom-center",
          //         autoClose: 4000,
          //         hideProgressBar: false,
          //         closeOnClick: true,
          //         pauseOnHover: true,
          //         draggable: true,
          //         progress: undefined,
          //       });
          //     } else {
          //       toast.error("सहेजने में विफल है. कृपया पुन: प्रयास करें।", {
          //         position: "bottom-center",
          //         autoClose: 4000,
          //         hideProgressBar: false,
          //         closeOnClick: true,
          //         pauseOnHover: true,
          //         draggable: true,
          //         progress: undefined,
          //       });
          //     }
          //   } else {
          //     //console.log("Upload api not working");
          //     toast.error("सहेजने में विफल है. कृपया पुन: प्रयास करें।", {
          //       position: "bottom-center",
          //       autoClose: 4000,
          //       hideProgressBar: false,
          //       closeOnClick: true,
          //       pauseOnHover: true,
          //       draggable: true,
          //       progress: undefined,
          //     });
          //   }
          //   setDisabled(false);
          // }
          //setDisabled(false);
        } catch (error) {
          if (error && error.response && error.response.data) {
            //console.log(error.response.data);
            let data = error.response.data;
            if (data.duplicate === true) {
              toast.error("इस ईमेल द्वारा पोस्ट पहले ही सबमिट कर दी गई है।", {
                position: "bottom-center",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else {
              toast.error("सहेजने में विफल है. कृपया पुन: प्रयास करें।", {
                position: "bottom-center",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          } else {
            console.log(error);
            //console.log("Upload api not working");
            toast.error("सहेजने में विफल है. कृपया पुन: प्रयास करें।", {
              position: "bottom-center",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          setDisabled(false);
        }
      }}
    >
      {({ values, setFieldValue, errors, touched }) => (
        <Form>
          {/* <div className="regBtn">Registration Form</div> */}
          <button disabled={true} className="submitBtn regBtn">
            REGISTRATION FORM
          </button>
          <div className="fieldContainer">
            <div className="fieldTitle">तुमचं पूर्ण नाव</div>
            <div className="completeName">
              <Field
                type="text"
                required
                name="firstName"
                maxLength={20}
                placeholder="पहिलं नाव"
                className="formikInput"
              />
              <Field
                type="text"
                required
                name="lastName"
                maxLength={20}
                placeholder="आडनाव"
                className="formikInput"
              />
            </div>
            {errors.firstName && touched.firstName ? (
              <div className="formikError">{errors.firstName}</div>
            ) : null}
            {errors.lastName && touched.lastName ? (
              <div className="formikError">{errors.lastName}</div>
            ) : null}
          </div>
          <div className="fieldContainer">
            <div className="fieldTitle">मोबाईल नंबर</div>
            <Field
              type="text"
              name="contactNo"
              required
              maxLength={10}
              placeholder="इथे लिहा +91"
              className="formikInput"
            />
            {errors.contactNo && touched.contactNo ? (
              <div className="formikError">{errors.contactNo}</div>
            ) : null}
          </div>

          <div className="fieldContainer">
            <div className="fieldTitle">तुमचा पत्ता</div>
            <Field
              type="text"
              required
              name="address"
              maxLength={100}
              placeholder="इथे लिहा"
              className="formikInput"
            />
            <div className="subAddress">
              <Field
                type="text"
                name="city"
                required
                maxLength={100}
                placeholder="शहर"
                className="formikInput"
              />
              <Field
                type="text"
                name="state"
                required
                maxLength={100}
                placeholder="राज्य"
                className="formikInput"
              />
              <Field
                type="tel"
                name="pincode"
                maxLength={10}
                minLength={6}
                required
                placeholder="पिन कोड"
                className="formikInput"
              />
            </div>
            {errors.address && touched.address ? (
              <div className="formikError">{errors.address}</div>
            ) : null}
            {errors.city && touched.city ? (
              <div className="formikError">{errors.city}</div>
            ) : null}
            {errors.state && touched.state ? (
              <div className="formikError">{errors.state}</div>
            ) : null}
            {errors.pincode && touched.pincode ? (
              <div className="formikError">{errors.pincode}</div>
            ) : null}
          </div>

          {/* <div className="fieldContainer">
            <div className="fieldTitle">ईमेल आई डी</div>
            <Field
              type="email"
              name="email"
              required
              maxLength={100}
              placeholder="e.g abc@gmail.com"
              className="formikInput"
            />
            {errors.email && touched.email ? (
              <div className="formikError">{errors.email}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">आधार कार्ड </div>
            <Field
              type="file"
              name="aadharCard"
              required
              value={undefined}
              accept="application/pdf,image/jpeg,image/jpg,image/png"
              onChange={(e) => {
                setFieldValue("aadharCard", e.target.files[0]);
              }}
              placeholder="e.g abc@gmail.com"
              className="formikInput"
            />
            <div style={{ color: "#6c757d", fontSize: "14px" }}>
              नोट :- .pdf/.jpg/.jpeg/.png (अधिकतम 5mb)
            </div>
            {errors.aadharCard && touched.aadharCard ? (
              <div className="formikError">{errors.aadharCard}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">आपकी रचना</div>
            <Field
              type="text"
              name="title"
              required
              placeholder="वे मरे, हारे नहीं, मरना कोई हार नहीं होती"
              className="formikInput"
            />
            {errors.title && touched.title ? (
              <div className="formikError">{errors.title}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">इंस्टाग्राम आईडी</div>
            <Field
              type="text"
              name="instagramId"
              required
              placeholder="इंस्टाग्राम आईडी"
              className="formikInput"
            />
            {errors.instagramId && touched.instagramId ? (
              <div className="formikError">{errors.instagramId}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">ऑडियो अपलोड करें</div>
            <Field
              type="file"
              name="audioFile"
              required
              value={undefined}
              accept="audio/mp3,audio/x-wav,audio/m4a,audio/ogg,audio/x-ms-wmamaudio/x-matroska,audio/x-aac,audio/midi"
              onChange={(e) => {
                setFieldValue("audioFile", e.target.files[0]);
              }}
              placeholder="e.g abc@gmail.com"
              className="formikInput"
            />
            <div style={{ color: "#6c757d", fontSize: "14px" }}>
              नोट :- mp3/wav/m4a/ogg/wma/mka/aac/midi (अधिकतम 50mb)
            </div>
            {errors.audioFile && touched.audioFile ? (
              <div className="formikError">{errors.audioFile}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">ट्विटर हैंडल</div>
            <Field
              type="text"
              name="twitterId"
              maxLength={100}
              placeholder="e.g twitter.com/aajtak"
              className="formikInput"
              required
            />
            {errors.twitterId && touched.twitterId ? (
              <div className="formikError">{errors.twitterId}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">हैशटैग सप्ताह</div>
            <Field
              type="text"
              name="hashtag"
              placeholder="हैशटैग"
              required
              maxLength={100}
              className="formikInput"
            />
            {errors.hashtag && touched.hashtag ? (
              <div className="formikError">{errors.hashtag}</div>
            ) : null}
          </div> */}
          {/* <div className="fieldContainer">
            <div className="fieldTitle">रचनात्मक लेखन (300 शब्द)</div>
            <Field name="postDescription">
              {({ field, form, meta }) => {
                return (
                  <textarea
                    placeholder={"अपना साहित्य रचना को यहाँ लिखें"}
                    name="postDescription"
                    value={form.value}
                    onChange={field.onChange}
                    required
                    maxLength={2000}
                    className="formikInput textarea"
                  />
                );
              }}
            </Field>
            {errors.postDescription && touched.postDescription ? (
              <div className="formikError">{errors.postDescription}</div>
            ) : null}
          </div> */}

          <div className="fieldContainer termsAndCondition">
            <div className="termInline">
              <Field
                type="checkbox"
                name="termsAccepted"
                required
                style={{
                  marginRight: 10,
                  height: 15,
                  width: 15,
                  border: 5,
                }}
              />
              <p className="termsPara">
                मी सर्व&nbsp;
                <span
                  style={{
                    display: "inline",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  role="button"
                  className="termsLink"
                  onClick={() => setPopState(true)}
                >
                  अटी व शर्ती
                </span>
                &nbsp; मान्य करतो
              </p>
              <Popup
                modal={true}
                overlayStyle={{
                  backdropFilter: "blur(1px)",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
                position="center center"
                open={popState}
                onClose={() => setPopState(false)}
                //contentStyle={{ width: "50%" }}
              >
                <div className="popTermsBody">
                  <button
                    className="close"
                    onClick={() => setPopState(false)}
                    style={{ height: 28, width: 28, marginBottom: 20 }}
                  >
                    &times;
                  </button>
                  <Rules />
                </div>
              </Popup>
            </div>
            <br />
            {errors.termsAccepted && touched.termsAccepted ? (
              <div className="formikError">{errors.termsAccepted}</div>
            ) : null}
          </div>

          <button disabled={disabled} type="submit" className="submitBtn">
            {disabled ? "SUBMITTING..." : "SUBMIT"}
          </button>
        </Form>
      )}
    </Formik>
  );
}
